module.exports = __webpack_public_path__ + "static/media/background05.aad9240c.jpg";